export const whyBannerData = {
  title: "WHY KAITHERO?",
  header:
    "We deliver!!!",//"The digital world is moving too fast, we will slow it down for your business.",
  reasons:
    "The digital world is moving too fast, we will slow it down for your business. Through our innovative solutions we will make it easier for you to integrate digital solutions to your ecosystem. We have a committed team which is available 24/7 to assist you enjoy the digital world. Our team is committed to deliver a top notch service.",
};
